<template>
  <div :class="insightClasses">
    <transition-group
      name="slide-fade"
      @before-enter="updateCurrentAnswer"
      @after-leave="afterLeave"
      @after-enter="$emit('after-enter')"
    >
      <div
        v-if="!isClosed"
        key='open'
        class="ds-insights__opened"
      >
        <div class="ds-insights__header">
          <label>
            <DsIcon
              size="small"
              name="insights"
            />
            Insigths
          </label>
          <div @click="toggleCardClosed">
            <DsIcon
              size="small"
              name="chevron-right"
            />
          </div>
        </div>
        <transition-group
          name="fade"
          @before-enter="updateCurrentAnswer"
          @after-leave="isChangingPage = false"
        >
          <div
            v-if="!isChangingPage"
            key='content'
            class="ds-insights__content"
          >
            <div class="ds-insights__title">
              {{ currentInsight.title }}
            </div>
            <div
              class="ds-insights__body"
              v-html="currentInsight.body"
            />
            <div class="ds-insights__actions">
              <template v-if="!wasCurrentAnswered">
                <span>Este insight foi útil?</span>
                <DsButton
                  size="dense"
                  color="secondary"
                  @click="actionHandler(true)"
                >
                  Sim
                </DsButton>
                <DsButton
                  size="dense"
                  color="secondary"
                  @click="actionHandler(false)"
                >
                  Não
                </DsButton>
              </template>
              <label v-else>Obrigado por classificar esse insight!</label>
            </div>
          </div>
        </transition-group>
        <div class="ds-insights__pages">
          <DsPageController
            v-if="numberOfpages > 1"
            v-model="page"
            @change="changePage"
            :size="numberOfpages"
          />
        </div>
      </div>
    </transition-group>
    <div
      v-if="wasFinishedClosing"
      class="ds-insights__closed"
    >
      <div @click="toggleCardClosed">
        <DsIcon
          size="small"
          name="insights"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck

import Vue from 'vue';
import { DsIcon } from '@ds/icons';
import DsButton from '../Button/Button.vue';
import DsPageController from '../PageController/PageController.vue';

export default Vue.extend({
  name: 'DsInsights',
  components: {
    DsIcon,
    DsButton,
    DsPageController
  },
  data() {
    return {
      page: 1,
      isClosed: false,
      isChangingPage: false,
      wasFinishedClosing: false,
      wasCurrentAnswered: false,
    };
  },
  props: {
    insights: {
      type: Array,
      required: true,
      validator(insights) {
        const hasCorrectFields = insights.every((insight) => {
          const keys = Object.keys(insight);
          return keys.includes('body') && keys.includes('title');
        });

        const hasCorrectSize = insights.length <= 6;

        if (!hasCorrectFields)
          throw new Error('"insights" prop must to be an object array, and each item must to have "title" and "body" string fields.');

        if (!hasCorrectSize)
          throw new Error('"insights" prop must to be a array with size between 1 and 6.');

        return hasCorrectFields && hasCorrectSize;
      }
    },
    dark: {
      type: Boolean,
      default: false,
    },
    startClosed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentInsightIndex() {
      return this.page - 1;
    },
    numberOfpages() {
      return this.insights.length;
    },
    currentInsight() {
      return this.insights[this.currentInsightIndex];
    },
    insightClasses() {
      return {
        'ds-insights': true,
        'ds-insights--closed': this.isClosed && this.wasFinishedClosing,
      };
    },
  },
  methods: {
    changePage() {
      this.isChangingPage = true;
      this.$emit('change-page');
    },
    updateCurrentAnswer() {
      this.wasCurrentAnswered = this.insights[this.currentInsightIndex].value !== undefined;
    },
    toggleCardClosed() {
      if(!this.wasFinishedClosing && this.isClosed) return;

      this.isClosed = !this.isClosed;
      this.wasFinishedClosing = false;
    },
    afterLeave() {
      this.wasFinishedClosing = true;
      this.$emit('after-leave');
    },
    actionHandler(value) {
      const payload = {
        feedback: {
          value,
          insight: this.currentInsight,
          index: this.currentInsightIndex,
        },
        allInsight: this.insights,
      };

      this.insights[this.currentInsightIndex].value = value;

      this.updateCurrentAnswer();
      this.$emit('feedback', payload);
    },
  },
  mounted() {
    this.insights.forEach(insight => {
      if ('value' in insight) return;
      insight.value = undefined;
    });

    this.isClosed = this.startClosed;

    this.updateCurrentAnswer();
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Insights.scss';
</style>
